import React from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { HelperTextProps } from "./HelperText.props";
import styles from "./HelperText.module.scss";

/**
 * @deprecated
 */
const HelperText: React.FC<HelperTextProps> = ({ id, body, isLoading = false }: HelperTextProps): JSX.Element => {
  const helperTextClasses = cn(styles["helper-text"]);

  if (!isLoading) {
    return (
      <div id={`${id}-helper-text`} className={helperTextClasses} data-testid={`test__${id}-helper-text`}>
        {body}
      </div>
    );
  }

  return <Skeleton />;
};
/**
 * @deprecated
 */

export default HelperText;
